import { render } from "./processes.vue?vue&type=template&id=7a9d5ca7&ts=true"
import script from "./processes.vue?vue&type=script&lang=ts"
export * from "./processes.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__